import { useState } from "react";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../recoil/pub.atom";
import { getPubLikes } from "../../../api/cafe";

export const useEventHook = () => {
  const [users, setUsers] = useState<string[]>([]);
  const pub = useRecoilValue(pubState);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;
  const getLikes = async () => {
    if (!pub) return;
    const res = await getPubLikes(pub.id);
    setUsers(res.users);
    setTotalPages(Math.max(1, Math.ceil(res.users.length / itemsPerPage)));
  };
  const isCheck = (count: number) => {
    if (count > users.length) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="59"
          height="59"
          viewBox="0 0 59 59"
          fill="none"
        >
          <circle
            cx="29.5"
            cy="29.5"
            r="27"
            fill="white"
            stroke="#7F25FB"
            stroke-width="5"
          />
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="59"
          height="59"
          viewBox="0 0 59 59"
          fill="none"
        >
          <circle
            cx="29.5"
            cy="29.5"
            r="27"
            fill="#7F25FB"
            stroke="#7F25FB"
            stroke-width="5"
          />
        </svg>
      );
    }
  };
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const paginatedList = users.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  return {
    users,
    getLikes,
    isCheck,
    currentPage,
    totalPages,
    paginatedList,
    handlePageChange,
  };
};
